import copy from "copy-to-clipboard";

type Scope = "local-url" | "default";

export const copyToClipboard = (text: string, scope: Scope = "default") => {
  if (scope === "local-url") {
    copy(`${window.location.origin}${text}`);
    return;
  }
  copy(text);
};
